import { FC } from 'react';
import { Anchor, Flex, Image, Text, UnstyledButton } from '@mantine/core';
import { UUID } from '@/types/types';
import { useDispatch } from 'react-redux';
import { creatorActions } from '@/store/slices/creatorSlice';
import classNames from 'classnames';
import HelpIcon from '@/assets/icons/help.svg?react';

interface Props {
	id?: UUID;
	isSelected: boolean;
	name: string;
	description?: string;
	onSelect: () => void;
	shopUrl?: string;
	imagePath?: string;
	onMouseOver?: () => void;
}

export const AccordionOptionCard: FC<Props> = ({
	id,
	isSelected,
	name,
	description,
	onSelect,
	shopUrl,
	imagePath,
	onMouseOver,
}) => {
	const dispatch = useDispatch();

	const handleOpenHelpDrawer = () => {
		dispatch(
			creatorActions.toogleHelpDrawer({
				helpDrawerOpened: true,
				helpDrawerData: {
					title: name,
					description,
					image: imagePath,
					shopUrl,
				},
			})
		);
	};

	return (
		<UnstyledButton
			key={id}
			className={classNames('option-card', {
				'option-card-selected': isSelected,
			})}
			p="xs"
			onClick={onSelect}
			onMouseOver={onMouseOver}
		>
			<Flex className="image-container">
				<Anchor
					className="help-trigger"
					onClick={(e) => {
						e.stopPropagation();
						handleOpenHelpDrawer();
					}}
				>
					<HelpIcon />
				</Anchor>
				<Image src={imagePath} w={125} h={125} mb="sm" loading="lazy" />
			</Flex>

			<Text size="xs" fw="bold" tt="uppercase">
				{name}
			</Text>
		</UnstyledButton>
	);
};
